<template>  
    <div class="portfolios-list">
      <!-- paging --> 
      <div class="pager-group"> 
        <div class="sort-selector">
          <template v-for="sortord in orderoptions">
            <span :class="sortord === order ? 'sort-option-selected' : 'sort-option'"
              @click="onOrderSelected(sortord)">
              {{sortord}}
            </span>
          </template>
        </div>
        <com-pager :page="page" :pagelen="pagelen" :total="total"
            @navigate="onNavigate"></com-pager>
      </div>
      <hr/>

      <div v-for="(portfolio, index) in portfolios" :key="index">
        <sig-portfolio-row :portfolio="portfolio" :class="(index & 1) ? 'portfolio-odd' : ''">
        </sig-portfolio-row>
      </div>
    </div>
</template>

<script>
  import SigPortfolioRow from './sig-portfolio-row.vue';
  import ComPager from './ui-components/ui-pager.vue';
  import { mapGetters, mapMutations } from 'vuex';
  
  export default {
      components: {
        'sig-portfolio-row': SigPortfolioRow,
        'com-pager': ComPager
      },
      props: [],
      data() {
        return {
          orderoptions: [ 'rating', 'profit', 'risk' ]
        };
      },
      computed: {
        ...mapGetters({
          portfolios: 'portfolios/portfolios',
          page: 'portfolios/page',
          total: 'portfolios/total',
          pagelen: 'portfolios/pagelen',
          order: 'portfolios/order'
        })
      },
      methods: {
        onNavigate(action) {
          this.$store.dispatch('portfolios/changePage', action);
        },
        onOrderSelected(sortord) {
          if (sortord === this.order) return;
          this.$store.dispatch('portfolios/applyOrder', sortord);
        }
      },
      beforeCreate() {
        this.$store.dispatch('portfolios/loadPortfolios');
      }
    };
</script>

<style scoped>
  .portfolios-list {
    width: 100%;
  }

  .pager-group {
    width: 70%; text-align: left
  }

  div.portfolios-paging {
    border-radius: .25rem;
    border: 1px solid rgba(0,0,0,.15);
    background: #f4f7ff;
  }

  div.portfolio-odd  {
    background: #F8F8F8;
  }

  .clickable-ico {
    cursor: pointer;
    margin-left: 9px;
    margin-right: 9px;
  }

  div.sort-selector {
    display: inline-block;
    width: 250px;
    border-radius: .25rem;
    border: 1px solid rgba(0,0,0,.15);
    background: #f4f7ff;
    padding-left: 12px;
  }

  .sort-option {
    color:#A0A097;
    cursor: pointer;
  }
  .sort-option:hover {
    color:#909067;
  }

  .sort-option-selected {
    color:#303017;
  }
</style>